var map = {
	"./chair.svg": 8894,
	"./rectangle-table-1-side.svg": 8597,
	"./rectangle-table-2-side.svg": 2252,
	"./rectangle-table-sitting.svg": 6782,
	"./rectangle-table.svg": 2057,
	"./round-table-sitting.svg": 5449,
	"./round-table.svg": 5482,
	"./square-table-sitting.svg": 8150,
	"./square-table.svg": 9857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3085;